import React from 'react';
import RemoveMoneyDeliveryButtonProperties from "./RemoveMoneyDeliveryButtonProperties";
import RemoveMoneyDeliveryStore from "./RemoveMoneyDeliveryStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useCommonContext} from "../../../contexts/CommonContext";
import useConfirmation from "../../../hooks/ConfirmationDialog";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import Button from "../../../ui_components/Button/Button";
import Icon from '../../../ui_components/Icon/Icon';
import IconName from '../../../ui_components/Icon/enums/IconName';
import {useUserContext} from "../../../contexts/UserContext";
import Access from "../../Access/AllowAccess/Access";


const RemoveMoneyDeliveryButton: React.FC<RemoveMoneyDeliveryButtonProperties> = ({
                                                                        onClick = () => {
                                                                        },
                                                                        onSave = () => {
                                                                        },
                                                                        showIcon = true,
                                                                        showText = true,
                                                                        disabled,
                                                                        className = '',
                                                                        moneyDeliveryOrderId,
                                                                        rounded = false,
                                                                        size = ButtonSize.DEFAULT,
                                                                        type = ButtonType.DEFAULT
                                                                    }) => {

    const confirm = useConfirmation();
    const userStore = useUserContext();
    const commonContext = useCommonContext();

    const store = new RemoveMoneyDeliveryStore(commonContext, moneyDeliveryOrderId);

    const handleOnclick = async () => {
        onClick();
        const ok = await confirm("Confirmación", "¿Está seguro que desea eliminar el envío?");
        if (ok) {
            await store.remove();
            onSave();
        }
    }

    const text = "Eliminar envío";
    if (!userStore.hasAccess(Access.REMOVE_MONEY_DELIVERY_ORDER.valueOf())) {
        return <></>;
    }

    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                size={size}
                type={type}
                icon={showIcon ? <Icon name={IconName.DELETE_ICON}/> : <></>}
            />
        }
        return <Button
            onClick={handleOnclick}
            className={className}
            disabled={disabled}
            tooltip={!showText ? text : ""}
            text={showText ? text : ""}
            size={size}
            type={type}
            startIcon={showIcon ? <Icon name={IconName.DELETE_ICON}/> : <></>}
        />
    }

    return <Observer>
        {() => (
            <Btn/>
        )}
    </Observer>
}

export default RemoveMoneyDeliveryButton;
